import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';

// Patch missing modules to prevent build errors
if (typeof window !== 'undefined') {
  window.stringUtils = {
    formatNumber: (num) => num,
    formatDate: (date) => date,
    shortenAddress: (address) => address,
    hexToText: (hex) => hex,
    stringToColor: () => '#000000',
    getInitial: () => '',
    formatPrice: (price) => price,
    formatRefreshTime: () => '',
    isNewToken: () => false
  };
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
); 
